import { render, staticRenderFns } from "./Title.vue?vue&type=template&id=5ca911aa&"
import script from "./Title.vue?vue&type=script&lang=js&"
export * from "./Title.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ca911aa')) {
      api.createRecord('5ca911aa', component.options)
    } else {
      api.reload('5ca911aa', component.options)
    }
    module.hot.accept("./Title.vue?vue&type=template&id=5ca911aa&", function () {
      api.rerender('5ca911aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/functional/Title.vue"
export default component.exports